import { Pipe, PipeTransform } from '@angular/core';

enum Taraf {
    YUKARI = 'up',
    ASAGI = 'down'
}

@Pipe({ name: 'yuvarla', standalone: true })
export class YuvarlaPipe implements PipeTransform {
    /**
     *
     * @param value - some number
     * @param digits - number of digits after the decimal point
     * @param dir - round up or down (floor/ceil)
     * @returns {string} formatted number with a fixed number of digits after the decimal point
     */
    transform(value: number, digits: number = 2, dir: Taraf = Taraf.YUKARI): number {
        const round = dir === Taraf.ASAGI ? Math.floor : Math.ceil;
        return round(value * (10 ** digits)) / (10 ** digits);
    }
}